/** Source unique des liens de navigation : barre haute et panneau mobile. */
export const NAV_LINKS = [
  { href: "#domicile", label: "À domicile" },
  { href: "#formules", label: "Formules" },
  { href: "#fonctionnement", label: "Comment ça marche" },
] as const
